<template>

  <v-container fluid class="px-0 receiver-order-info-tracking-history">

    <!-- Order Tracking History -->
    <order-tracking-history class="pl-10 page-content" :order="order" />

  </v-container>

</template>

<script>
import OrderTrackingHistory from '@/components/orders/OrderTrackingHistory'

export default {
  name: 'ReceiverOrderInfoTrackingHistory',

  components: {
    OrderTrackingHistory
  },

  props: {
    orderId: {
      type: String,
      default: null
    }
  },

  computed: {
    order () {
      return this.$parent.order
    }
  }
}
</script>

<style>
</style>
